import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderMediaFieldRenderer } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-media-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderMediaField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext,
  accept?: string
): string {
  const acceptProp = accept ? `\n${indent}          accept="${accept}"` : ''
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const onChange = defaultValueFromHandler
    ? renderMediaFieldRenderer({
        kind: 'renderMediaFieldChangeHandlerTemplate',
        props: {
          indent: indent,
          defaultValueFromHandler: defaultValueFromHandler
        }
      })
    : 'formField.onChange'
  return renderMediaFieldRenderer({
    kind: 'renderMediaFieldFormFieldTemplate',
    props: {
      indent: indent,
      fieldName: field.name,
      formItemProps: formItemProps(field),
      labelWithDescription: labelWithDescription(
        formLabel(field, label),
        hintJSX,
        `${indent}      `
      ),
      onChange: onChange,
      acceptProp: acceptProp
    }
  })
}
